module.exports = __webpack_public_path__ + "static-v-shop/1785501885960/img/frame.442faa53.webp";